import { Layout, Typography } from "antd";
import { TitleProps } from "antd/es/typography/Title";
import { FC } from "react";
const { Header } = Layout;
const { Title } = Typography;

interface SectionHeaderProps {
    title: string;
    level?: TitleProps["level"];
    className?: string;
}

export const SectionHeader: FC<SectionHeaderProps> = ({ title, level, className }) => {
    return (
        <div className={className ?? "my-4"}>
            <Header className="bg-transparent p-0">
                <div>
                    <Title level={level ?? 1}>{title}</Title>
                </div>
            </Header>
        </div>
    );
};
